import { useCallback } from 'react';
import { useMutation } from '@apollo/client';

import setPreferredForAutopayMutationGraphql from '../../../../../graphql/mutations/renter_payment_methods/setPreferredForAutopay.graphql';
import setPreferredForRentPaymentsMutationGraphql from '../../../../../graphql/mutations/renter_payment_methods/setPreferredForRentPayments.graphql';
import setPreferredForRentReportingMutationGraphql from '../../../../../graphql/mutations/renter_payment_methods/setPreferredForRentReporting.graphql';

const useSetPreferred = (leaseId) => {
  const [
    setPreferredForAutopayMutation,
    { loading: savingPreferredForAutopay },
  ] = useMutation(setPreferredForAutopayMutationGraphql);
  const [
    setPreferredForRentPaymentsMutation,
    { loading: savingPreferredForRentPayments },
  ] = useMutation(setPreferredForRentPaymentsMutationGraphql);

  const [setPreferredForRentReportingMutation] = useMutation(
    setPreferredForRentReportingMutationGraphql,
  );

  const setPreferredForAutopay = useCallback(async (paymentMethod) => {
    await setPreferredForAutopayMutation({
      variables: {
        id: paymentMethod.id,
        activeLeaseId: leaseId,
      },
    });
  }, []);

  const setPreferredForRentPayments = useCallback(async (paymentMethod) => {
    await setPreferredForRentPaymentsMutation({
      variables: {
        id: paymentMethod.id,
        activeLeaseId: leaseId,
      },
    });
  }, []);

  const setPreferredForRentReporting = useCallback(async (paymentMethod) => {
    await setPreferredForRentReportingMutation({
      variables: {
        id: paymentMethod.id,
        activeLeaseId: leaseId,
      },
    });
  }, []);

  return {
    setPreferredForAutopay,
    savingPreferredForAutopay,
    setPreferredForRentPayments,
    setPreferredForRentReporting,
    savingPreferredForRentPayments,
  };
};

export default useSetPreferred;
